import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Button,
  Flex,
  useColorMode,
  Slide
} from '@chakra-ui/react';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { colorMode } = useColorMode();
  
  useEffect(() => {
    const dismissed = localStorage.getItem('noticeDismissed');
    if (!dismissed) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const handleDismiss = () => {
    localStorage.setItem('noticeDismissed', 'true');
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <Slide direction="bottom" in={showBanner} style={{ zIndex: 100 }}>
      <Box
        p={4}
        bg={colorMode === 'dark' ? 'gray.800' : 'white'}
        boxShadow="0 -2px 20px rgba(0,0,0,0.06)"
        borderTop="1px solid"
        borderTopColor={colorMode === 'dark' ? 'gray.700' : 'gray.100'}
      >
        <Flex 
          direction={{ base: 'column', md: 'row' }} 
          justify="space-between" 
          align={{ base: 'flex-start', md: 'center' }}
          maxW="1200px"
          mx="auto"
          gap={4}
        >
          <Text fontSize="sm" color={colorMode === 'dark' ? 'gray.300' : 'gray.600'} lineHeight="1.6">
            Tento web <strong>nepoužívá</strong> žádné sledovací ani analytické cookies. 
            Kontaktní a rezervační formulář zpracovávají vaše údaje výhradně za účelem vyřízení vašeho dotazu nebo rezervace. 
            Více informací v{' '}
            <Text
              as="span"
              cursor="pointer"
              textDecoration="underline"
              onClick={() => window.open('/privacy-policy', '_blank')}
            >
              zásadách ochrany osobních údajů
            </Text>
            .
          </Text>
          <Button 
            size="sm"
            variant="outline"
            borderRadius="2px"
            borderColor={colorMode === 'dark' ? 'gray.500' : 'gray.300'}
            color={colorMode === 'dark' ? 'gray.300' : 'gray.600'}
            _hover={{ borderColor: colorMode === 'dark' ? 'white' : 'black', color: colorMode === 'dark' ? 'white' : 'black' }}
            onClick={handleDismiss}
            minW="80px"
          >
            Rozumím
          </Button>
        </Flex>
      </Box>
    </Slide>
  );
};

export default CookieConsent;
